import { DataService } from './../../../../../services/data.service';
import { BreadCrumb } from './../../../../../interfaces/main';
import { ReviewType } from './../../../../../interfaces/enums';
import { AuthService } from './../../../../../services/auth.service';
import { Student } from './../../../../../interfaces/user';
import { ActivatedRoute, Router } from '@angular/router';
import { Lesson } from './../../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';
import { Teacher } from 'src/app/interfaces/user';
import { BehaviorSubject } from 'rxjs';

import * as _ from 'lodash';

enum Tabs{
  Lessons = 1,
  Reviews = 2
}

@Component({
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.scss']
})

export class SingleTeacherComponent implements OnInit {

  Tabs = Tabs;
  ReviewType = ReviewType;

  lessons: Lesson[];

  currentTab = Tabs.Lessons;

  teacher: Teacher;
  user: Student;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'Teachers',
    url: ['/teachers']
  }]

  canLeaveReviewSubject = new BehaviorSubject(false);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private data: DataService
  ) {}

  getNumberOfSessions = () => this.lessons && this.lessons.length ? _.reduce(this.lessons, (sum, v: Lesson) => sum += v.sessions.length, 0) : 0;

  ngOnInit() {
    this.route.params.subscribe(async (p) => {
      if(p.teacherid){
        this.user = await this.auth.getUser() as Student;
        this.getData(p.teacherid);
      }else{
        this.router.navigate(['/teachers']);
      }
    })
  }

  getData(teacherid: string){
    this.data.getUser(teacherid).subscribe((res) => {
      if(res && res.data){
        this.teacher = res.data;

        this.getLessons();
        this.canLeaveReview();

        this.breadcrumbs.length = 2;
        this.breadcrumbs.push({
          link: this.teacher.name
        })
      }
    });
  }

  getLessons(){
    this.data.getLessons(undefined, {
      teacher_id: this.teacher._id
    }).subscribe((res) => {
      if(res && res.data){
        this.lessons = res.data;
      }
    })
  }

  /**
   * Functions checks if user is allowed to leave a review
   */
  canLeaveReviewObservable = () => this.canLeaveReviewSubject.asObservable();
  async canLeaveReview(){
    if(!this.user){
      this.canLeaveReviewSubject.next(false);
      return;
    }

    this.data.getReviews({from: this.user._id, to: this.user._id}).subscribe((res) => {
      if(res && res.data){
        this.canLeaveReviewSubject.next(!res.data.length);
      }
    })
  }
}
